import React from "react";
import LeftMenu from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/LeftMenu";
import Category from "../VFL/Category";
import OneColumnTable from "../OneColumnTable";

const Training = () => {
  return (
    <div className="healthSafetyEnvironmentWrapper">
      <LeftMenu active={2} />

      <div className="tst-class mt-4">
        <Category title="Category" name="Category" source="training" />

        <div className="training-seperator"></div>

        <OneColumnTable title="Designation" name="Designation" type="training" />
      </div>
    </div>
  );
};

export default Training;
